/* =====================================================================
   ExtraCM · tema de Shopify · JS compartido
   ---------------------------------------------------------------------
   · mercado (unidad, umbral de envío gratis, "precio tachado") por país
   · formato de moneda deducido de una muestra que pinta Liquid
   · carrito sobre la Ajax Cart API de Shopify (/cart.js, /cart/add.js…)
   · el cajón del carrito de /buy, con protección del paquete y cross-sells
   · localización de los importes decorativos y del umbral de envío
   Los textos salen de window.ECM_T (snippets/ecm-i18n.liquid).
   ===================================================================== */
(function () {
  'use strict';
  var ECM = window.ECM || {};
  var T = window.ECM_T || {};

  /* ---------------- textos ---------------- */
  // t('{n} pairs', {n: 2}) → "2 pares". Admite {n<5?pary:par} para plurales.
  function t(s, vars) {
    var v = Object.prototype.hasOwnProperty.call(T, s) ? T[s] : s;
    if (vars) {
      // el diccionario llega escapado: "{n<5?pary:par}" viene como "{n&lt;5?pary:par}" (polaco y checo salían sin resolver)
      v = v.replace(/\{(\w+)\s*(&lt;=|&gt;=|&lt;|&gt;|<=|>=|==|!=|<|>)\s*(\d+)\?([^:}]*):([^}]*)\}/g, function (m, k, op, num, a, b) {
        op = op.replace('&lt;', '<').replace('&gt;', '>');
        var x = Number(vars[k]), y = Number(num), ok;
        if (op === '<') ok = x < y; else if (op === '>') ok = x > y; else if (op === '<=') ok = x <= y;
        else if (op === '>=') ok = x >= y; else if (op === '==') ok = x === y; else ok = x !== y;
        return ok ? a : b;
      });
      Object.keys(vars).forEach(function (k) { v = v.split('{' + k + '}').join(vars[k]); });
    }
    return v;
  }
  // t() devuelve el texto escapado (para innerHTML); para textContent, tt() lo deja en texto plano
  // (si no, el francés enseñaba "attirer l&#39;attention")
  var unescBox = document.createElement('textarea');
  function tt(s, vars) { unescBox.innerHTML = t(s, vars); return unescBox.value; }

  /* ---------------- mercado ----------------
     Copiado de buy/index.html (MARKETS). Las bases de precio ya NO están
     aquí: las da Shopify en la moneda del mercado. Quedan la unidad, el
     recargo del precio tachado y el umbral de envío gratis, que Shopify no
     expone en Liquid. fx sirve solo para los importes decorativos. */
  var MARKETS = {
    // 24-oct-2026: tachado ≈ 1,22 × el par (en euros 40,99 → 49,99): recargos subidos en la misma proporción
    GB: { cur: 'GBP', unit: 'in', fx: 1, surplus: 8, bundleSurplus: 22, freeShip: 40 },
    US: { cur: 'USD', unit: 'in', fx: 1.40, surplus: 10, bundleSurplus: 31, freeShip: 60 },
    CA: { cur: 'CAD', unit: 'in', fx: 1.80, surplus: 13, bundleSurplus: 40, freeShip: 65 },
    EU: { cur: 'EUR', unit: 'cm', fx: 1.20, surplus: 9, bundleSurplus: 26, freeShip: 50 },
    IE: { cur: 'EUR', unit: 'in', fx: 1.20, surplus: 9, bundleSurplus: 26, freeShip: 50 },
    GR: { cur: 'EUR', unit: 'cm', fx: 1, surplus: 8, bundleSurplus: 22, freeShip: 50 },
    PL: { cur: 'PLN', unit: 'cm', fx: 4.40, surplus: 33, bundleSurplus: 97, freeShip: 179 },
    MX: { cur: 'MXN', unit: 'cm', fx: 18, surplus: 120, bundleSurplus: 360, freeShip: 749 },
    AU: { cur: 'AUD', unit: 'cm', fx: 2, surplus: 15, bundleSurplus: 44, freeShip: 80 },
    NZ: { cur: 'NZD', unit: 'cm', fx: 2.40, surplus: 18, bundleSurplus: 53, freeShip: 95 },
    CZ: { cur: 'CZK', unit: 'cm', fx: 25, surplus: 190, bundleSurplus: 550, freeShip: 999 },
    CL: { cur: 'CLP', unit: 'cm', fx: 1050, surplus: 7000, bundleSurplus: 21000, freeShip: 44990 },
    CO: { cur: 'COP', unit: 'cm', fx: 3600, surplus: 24000, bundleSurplus: 72000, freeShip: 160000 },
    PE: { cur: 'PEN', unit: 'cm', fx: 4, surplus: 30, bundleSurplus: 88, freeShip: 175 },
    PA: { cur: 'PAB', unit: 'cm', fx: 1.20, surplus: 9, bundleSurplus: 26, freeShip: 60 },
    UY: { cur: 'UYU', unit: 'cm', fx: 48, surplus: 360, bundleSurplus: 1056, freeShip: 2100 },
    JP: { cur: 'JPY', unit: 'cm', fx: 200, surplus: 1600, bundleSurplus: 4900, freeShip: 8000 }
  };
  var EU_COUNTRIES = ['AT', 'BE', 'DE', 'ES', 'FR', 'IT', 'NL', 'PT', 'LU'];
  /* Mercados INTERNACIONAL e INTERNACIONAL USD (30-oct-2026): el resto del mundo en inglés con la divisa
     de cada país. Los precios son los de EUROPA (catálogo compartido, 40,99 € el par de 5 cm) convertidos
     por Shopify; los países cuya moneda no soporta Shopify Payments pagan en dólares esos mismos precios
     convertidos a mano (lista "Precios INTERNACIONAL USD"). No hay una entrada por país: la unidad es cm
     y fx, recargo y umbral se derivan de la razón entre el precio que Shopify ya da en la moneda del
     visitante y el precio en euros. Las dos constantes tienen que coincidir con la lista EUROPA y con la
     zona INTERNACIONAL (3,99 €, gratis desde 50 €). El umbral se redondea HACIA ARRIBA a dos cifras
     (HK$436,7 → HK$440): la barra nunca promete el envío gratis antes de que el checkout lo dé. */
  var INTL = { price5Eur: 40.99, freeShipEur: 50 };
  function intlMarket() {
    var p5 = ECM.products && ECM.products['5'], k = p5 && p5.price > 0 ? p5.price / 100 / INTL.price5Eur : 0;
    if (!k) return null;
    var dec = parseFmt(ECM.moneySample).decimals, eu = MARKETS.EU;
    function r(v) { return dec ? Math.round(v * 100) / 100 : Math.round(v); }
    function niceCeil(v) { var mag = Math.pow(10, Math.max(0, Math.floor(Math.log(v) / Math.LN10) - 1)); return Math.ceil(v / mag - 1e-9) * mag; }
    return { cur: ECM.currency, unit: 'cm', fx: k * eu.fx, surplus: r(eu.surplus * k), bundleSurplus: r(eu.bundleSurplus * k), freeShip: niceCeil(INTL.freeShipEur * k) };
  }
  function detectMarket() {
    var c = ECM.country || 'GB', m = MARKETS[c] || (EU_COUNTRIES.indexOf(c) !== -1 ? MARKETS.EU : null);
    // País sin entrada propia = mercado INTERNACIONAL: su moneda ya la trae Shopify
    if (!m && ECM.currency) m = intlMarket();
    // Un país sin mercado propio compra con la moneda del mercado primario:
    // se busca la entrada que cobre en esa moneda, y si no, Reino Unido.
    if (!m || (ECM.currency && m.cur !== ECM.currency)) {
      var k = Object.keys(MARKETS).filter(function (x) { return MARKETS[x].cur === ECM.currency; })[0];
      m = k ? MARKETS[k] : (m || MARKETS.GB);
    }
    return m;
  }
  var CUR = detectMarket();
  // 24-oct-2026 (usuario): el tachado del pack de 3 alturas es 3 × el tachado del par de 5 cm (3 × 49,99 = 149,97 € → "ahorra 37 %"),
  // igual en la ficha, la portada y el carrito. Antes cada sitio usaba un tachado distinto (122,97 / 120,99 / recargo fijo).
  (function () {
    var P = ECM.products || {}, p5 = P['5'], pb = P.bundle;
    if (p5 && pb && p5.price > 0 && pb.price > 0) CUR.bundleSurplus = Math.round((3 * (p5.price / 100 + CUR.surplus) - pb.price / 100) * 100) / 100;
  })();

  /* ---------------- moneda ----------------
     Liquid pinta {{ 123456 | money }} ("£1,234.56", "1.234,56 €", "$1.235"…)
     y de ahí se deduce prefijo, sufijo, separadores y decimales. */
  function parseFmt(sample) {
    var m = /^([^\d]*)(\d[\d\s.,'’]*\d|\d)([^\d]*)$/.exec(String(sample || '').trim());
    if (!m) return { prefix: '£', suffix: '', dec: '.', group: ',', decimals: 2 };
    var num = m[2], digits = num.replace(/\D/g, ''), decimals = 0, dec = '.';
    if (/56$/.test(digits) && digits.length >= 5) { decimals = 2; dec = num.charAt(num.length - 3); }
    var gm = /^1(\D)\d{3}/.exec(num);
    return { prefix: m[1], suffix: m[3], dec: dec, group: gm ? gm[1] : '', decimals: decimals };
  }
  var FMT = parseFmt(ECM.moneySample);
  // Mismo formato que la web (MARKETS en buy/index.html). Sin esto Shopify pintaba
  // "€39,99" donde la web pone "39,99 €", o "$ 540.00" donde pone "$540.00".
  var WEB_FMT = {
    EUR: { prefix: '', suffix: ' €', dec: ',', group: '' },
    PLN: { prefix: '', suffix: ' zł', dec: ',', group: '' },
    CZK: { prefix: '', suffix: ' Kč', dec: ',', group: ' ' },
    MXN: { prefix: '$', suffix: '', dec: '.', group: ',' },
    CLP: { prefix: '$', suffix: '', dec: ',', group: '.', decimals: 0 },
    COP: { prefix: '$', suffix: '', dec: ',', group: '.', decimals: 0 },
    PEN: { prefix: 'S/ ', suffix: '', dec: '.', group: ',' },
    PAB: { prefix: 'B/. ', suffix: '', dec: '.', group: ',' },
    UYU: { prefix: '$', suffix: '', dec: ',', group: '.' },
    USD: { prefix: '$', suffix: '' }, CAD: { prefix: '$', suffix: '' },
    AUD: { prefix: '$', suffix: '' }, NZD: { prefix: '$', suffix: '' }, GBP: { prefix: '£', suffix: '' },
    JPY: { prefix: '¥', suffix: '', dec: '.', group: ',', decimals: 0 }
  };
  (function (o) { if (o) for (var k in o) FMT[k] = o[k]; })(WEB_FMT[ECM.currency]);
  function money(cents, trim) {
    var s = (Number(cents) / 100).toFixed(FMT.decimals), p = s.split('.'), i = p[0], d = p[1];
    if (FMT.group) i = i.replace(/\B(?=(\d{3})+(?!\d))/g, FMT.group);
    var out = i;
    if (d != null && !(trim && /^0+$/.test(d))) out += FMT.dec + d;
    return FMT.prefix + out + FMT.suffix;
  }
  function moneyMajor(v, trim) { return money(Math.round(v * 100), trim); }

  /* ---------------- tallas por país ----------------
     Misma tabla que la web: UK en Reino Unido/Irlanda, AU/NZ (= numeración
     británica), US en EE. UU./Canadá, centímetros de pie en México, EU en
     el resto. */
  var SIZE_SYS = { GB: ['UK', 'uk'], IE: ['UK', 'uk'], AU: ['AU', 'uk'], NZ: ['NZ', 'uk'], US: ['US', 'us'], CA: ['US', 'us'], MX: ['MX', 'mx'], JP: ['', 'jp'] };
  /* 23-oct-2026: tres tallas (acordado con el proveedor): S 35–38 · M 39–41 · L 42–46.
     La XL ya no se vende; se deja su rango antiguo solo para carritos que aún la lleven. */
  var SIZE_RANGES = {
    uk: { S: '2–5', M: '5.5–7', L: '8–11', XL: '10–11' },
    eu: { S: '35–38', M: '39–41', L: '42–46', XL: '44–46' },
    us: { S: '3–6', M: '6.5–8', L: '9–12', XL: '11–12' },
    mx: { S: '22–24', M: '24.5–26', L: '27–30', XL: '29–30' },
    // Japón: centímetros con medias tallas (tabla propia, NO la de México)
    jp: { S: '22.0–24.0 cm', M: '24.5–26.0 cm', L: '26.5–30.0 cm', XL: '28.0–30.0 cm' }
  };
  function sizeSystem() { return SIZE_SYS[ECM.country] || ['EU', 'eu']; }
  // Referencia bajo la talla principal, como en la web: EU debajo de UK/US/AU/NZ/MX;
  // en Colombia, Chile y Perú el centímetro (la británica allí no dice nada); UK en el resto.
  var CM_REF = ['CL', 'CO', 'PE'];
  function sizeAlt(s) {
    var sys = sizeSystem();
    if (sys[1] !== 'eu') return 'EU ' + SIZE_RANGES.eu[s];
    if (CM_REF.indexOf(ECM.country) !== -1) return SIZE_RANGES.mx[s] + ' cm';
    return 'UK ' + SIZE_RANGES.uk[s];
  }
  function sizeRange(s) {
    var sys = sizeSystem();
    return (sys[0] ? sys[0] + ' ' : '') + (SIZE_RANGES[sys[1]][s] || s) + ' · ' + sizeAlt(s);
  }
  // solo la numeración del país ("EU 42–46" en España, "UK 8–11" en Reino Unido, cm en Japón/Latam)
  function sizeMain(s) {
    var sys = sizeSystem();
    return (sys[0] ? sys[0] + ' ' : '') + (SIZE_RANGES[sys[1]][s] || s);
  }
  // Los botones de talla vienen traducidos por IDIOMA (el español es el de España):
  // se reetiquetan por PAÍS para que un mexicano o un colombiano vea lo mismo que en la web.
  function relabelSizes() {
    var sys = sizeSystem();
    [['.size', '.size__label', '.size__range', '.size__range-alt'], ['.cart-size', '.cart-size__label', '.cart-size__range', '.cart-size__range-alt']].forEach(function (q) {
      Array.prototype.forEach.call(document.querySelectorAll(q[0]), function (b) {
        var lab = b.querySelector(q[1]), main = b.querySelector(q[2]), alt = b.querySelector(q[3]);
        var s = lab && lab.textContent.trim();
        if (!s || !SIZE_RANGES.eu[s]) return;
        if (main) main.textContent = (sys[0] ? sys[0] + ' ' : '') + SIZE_RANGES[sys[1]][s];
        if (alt) alt.textContent = sizeAlt(s);
      });
    });
  }
  relabelSizes();

  /* ---------------- alturas ---------------- */
  var HEIGHT_IN = { '3': '+1.2"', '5': '+2.0"', '7': '+2.8"' };
  var HEIGHT_CM = { '3': '+3 cm', '5': '+5 cm', '7': '+7 cm' };
  function heightLabel(h) {
    if (h === 'bundle') return t('BUNDLE · 3 heights');
    return CUR.unit === 'cm' ? (HEIGHT_CM[h] || '+' + h + ' cm') : (HEIGHT_IN[h] || '+' + h + '"');
  }
  var HANDLE_TO_HEIGHT = {};
  Object.keys(ECM.products || {}).forEach(function (h) { if (ECM.products[h]) HANDLE_TO_HEIGHT[ECM.products[h].handle] = h; });

  /* ---------------- importes decorativos y umbral de envío ----------------
     Los textos traducidos llevan los importes de su mercado base (en: £,
     es/de/fr/it/pt/el/nl: €, pl: zł, cs: Kč). Cuando el visitante compra en
     otra moneda (un mexicano leyendo en español, un americano en inglés) se
     reconvierten con el fx del mercado, igual que hacía la web. */
  var LOCALE_BASE = {
    en: { cur: 'GBP', fx: 1, token: '£40', re: /£\s*([\d,]+(?:\.\d{1,2})?)(K)?/g, parse: function (s) { return parseFloat(s.replace(/,/g, '')); } },
    eur: { cur: 'EUR', fx: 1.20, token: '50 €', re: /(\d{1,3}(?:[.\s]\d{3})*(?:,\d{1,2})?)\s?€|€\s?(\d{1,3}(?:[.\s]\d{3})*(?:,\d{1,2})?)/g, parse: function (s) { return parseFloat(s.replace(/[.\s]/g, '').replace(',', '.')); } },
    pl: { cur: 'PLN', fx: 4.40, token: '179 zł', re: /(\d{1,3}(?:\s\d{3})*(?:,\d{1,2})?)\s?zł/g, parse: function (s) { return parseFloat(s.replace(/\s/g, '').replace(',', '.')); } },
    ja: { cur: 'JPY', fx: 200, token: '¥8,000', re: /¥\s*([\d,]+)/g, parse: function (s) { return parseFloat(s.replace(/,/g, '')); } },
    cs: { cur: 'CZK', fx: 25, token: '1 200 Kč', re: /(\d{1,3}(?:\s\d{3})*(?:,\d{1,2})?)\s?Kč/g, parse: function (s) { return parseFloat(s.replace(/\s/g, '').replace(',', '.')); } }
  };
  function localeBase() {
    var l = String(ECM.locale || 'en').toLowerCase().split('-')[0];
    if (l === 'en') return LOCALE_BASE.en;
    if (l === 'pl') return LOCALE_BASE.pl;
    if (l === 'cs') return LOCALE_BASE.cs;
    if (l === 'ja') return LOCALE_BASE.ja;
    var b = Object.assign({}, LOCALE_BASE.eur);
    if (l === 'nl') b.token = '€ 50';
    return b;
  }
  var BASE = localeBase();
  function needsConversion() { return BASE.cur !== CUR.cur; }
  function convertDecorative(html) {
    if (!needsConversion()) return html;
    return html.replace(BASE.re, function (m, a, b) {
      var raw = a || b, k = (BASE === LOCALE_BASE.en && b === 'K');
      if (BASE === LOCALE_BASE.en) { raw = a; }
      var v = BASE.parse(raw) / BASE.fx * CUR.fx;
      if (k) return FMT.prefix + Math.round(v) + 'K' + FMT.suffix;
      return moneyMajor(v);
    });
  }
  function localizeStatic(root) {
    root = root || document;
    if (!needsConversion()) return;
    // 1. umbral de envío gratis en los textos fijos ("Free shipping over £40")
    var th = moneyMajor(CUR.freeShip, true), drawer = document.getElementById('drawer');
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (!n.nodeValue || n.nodeValue.indexOf(BASE.token) === -1) return NodeFilter.FILTER_REJECT;
      for (var p = n.parentNode; p; p = p.parentNode) {
        if (p === drawer || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    } });
    var arr = [], n; while ((n = w.nextNode())) arr.push(n);
    arr.forEach(function (node) { node.nodeValue = node.nodeValue.split(BASE.token).join(th); });
    // 2. importes decorativos (valor de los regalos, estadísticas)
    var sel = '.bonus-item__was-top, .pack-includes-price, .pack-includes-total-amount, .bonuses__total, .science-stat__num, .size-card__features li';
    Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.innerHTML = convertDecorative(el.innerHTML); });
  }

  /* Importes en libras que se quedaron dentro de las traducciones (el valor de los regalos de la
     ficha): en español, japonés… salían "£12.95". Se pasan a la moneda del país con el cambio
     de la libra, aunque el idioma ya esté en la moneda del país (España: no hay "conversión"). */
  function convertGbpLeft(root) {
    if (CUR.cur === 'GBP' || BASE === LOCALE_BASE.en) return;
    var E = LOCALE_BASE.en;
    Array.prototype.forEach.call((root || document).querySelectorAll('.bonus-item__was-top, .bonuses__total, .pack-includes-price, .pack-includes-total-amount'), function (el) {
      if (el.innerHTML.indexOf('£') === -1) return;
      el.innerHTML = el.innerHTML.replace(E.re, function (m, a) { return moneyMajor(E.parse(a) / E.fx * CUR.fx); });
    });
  }

  /* ---------------- Ajax Cart API ----------------
     routes.root_url es "/" en el idioma principal pero "/es" (sin barra
     final) en los demás: sin normalizar salía "/escart.js" → 404. */
  var ROOT = String(ECM.root || '/').replace(/\/?$/, '/');
  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw Object.assign(new Error(j.description || j.message || 'cart error'), { data: j }); return j; });
    });
  }
  var cart = null;
  var listeners = [];
  function setCart(c) { cart = c; listeners.forEach(function (fn) { try { fn(cart); } catch (e) { console.error(e); } }); return cart; }
  var Cart = {
    get: function () { return cart; },
    refresh: function () { return api('cart.js').then(setCart); },
    add: function (items) { return api('cart/add.js', { items: items }).then(Cart.refresh); },
    change: function (key, quantity) { return api('cart/change.js', { id: key, quantity: quantity }).then(setCart); },
    update: function (data) { return api('cart/update.js', data).then(setCart); },
    onChange: function (fn) { listeners.push(fn); }
  };

  function isProtection(item) { return !!(ECM.protection && item.variant_id === ECM.protection.id); }
  function protectionOff() { try { return localStorage.getItem('ecm_protect_off') === '1'; } catch (e) { return false; } }
  function hasProtection() { return !!(cart && cart.items.some(isProtection)); }
  // Añadir al carrito: si es la primera línea y la protección no está apagada
  // a propósito, entra también (la web la activaba por defecto).
  // 26-oct-2026: se lee el carrito ANTES de decidir. Con dos pestañas abiertas (el carrito es el mismo) cada una creía
  // que estaba vacío y metía su protección: 2 unidades, 3,99 € de más (el pie solo enseña el precio de una).
  function addWithProtection(items) {
    return Cart.refresh().catch(function () {}).then(function () {
      var list = items.slice();
      if (ECM.protection && !hasProtection() && !protectionOff() && (!cart || cart.items.filter(function (i) { return !isProtection(i); }).length === 0)) {
        list.push({ id: ECM.protection.id, quantity: 1 });
      }
      return Cart.add(list);
    });
  }
  // la protección es por pedido: si el carrito trae más de 1 (pestañas, carritos viejos), se deja en 1
  var fixingProt = false;
  function fixProtectionQty(c) {
    if (fixingProt || !c || !ECM.protection) return;
    var pl = c.items.filter(isProtection)[0];
    if (pl && pl.quantity > 1) { fixingProt = true; Cart.change(pl.key, 1).catch(function () {}).then(function () { fixingProt = false; }); }
  }

  /* ---------------- cajón del carrito ---------------- */
  var $ = function (id) { return document.getElementById(id); };
  var drawer = $('drawer'), overlay = $('overlay'), drawerBody = $('drawerBody'), drawerFoot = $('drawerFoot');
  var drawerSub = $('drawerSub'), drawerDisc = $('drawerDisc'), drawerDiscAmt = $('drawerDiscAmt');
  var drawerShip = $('drawerShip'), drawerShipMsg = $('drawerShipMsg'), drawerShipFill = $('drawerShipFill'), drawerShipSub = $('drawerShipSub');
  var drawerLowstock = $('drawerLowstock'), drawerReserve = $('drawerReserve');
  var reserveModal = $('reserveModal'), reserveModalBody = $('reserveModalBody');
  var checkoutBtn = $('checkoutBtn'), drawerClose = $('drawerClose'), cartBadge = $('cartBadge');

  var XS_META = { 'stand-tall': { rating: 4.7, reviews: '2,341', desc: 'Shoulders & upper back, under your clothes', img: 'xsStandTall' },
    'jawline-trainer-2-pack': { rating: 4.6, reviews: '1,808', desc: 'Sharper jawline', img: 'xsMewing' },
    'gravity-pheromones': { rating: 4.8, reviews: '3,102', desc: 'Turn heads', img: 'xsPheromones' } };
  var XS = (ECM.crossSells || []).map(function (x) { return Object.assign({}, x, XS_META[x.handle] || {}); });
  function xsOf(item) { return XS.filter(function (x) { return x.id === item.variant_id; })[0]; }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart() {
    if (!drawerBody || !cart) return;
    var lines = cart.items.filter(function (i) { return !isProtection(i); });
    var totalQty = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (cartBadge) { cartBadge.textContent = totalQty; cartBadge.hidden = totalQty === 0; cartBadge.classList.toggle('show', totalQty > 0); }

    if (!lines.length) {
      drawerBody.innerHTML = '<div class="drawer__empty"><strong>' + t('Your cart is empty') + '</strong><span>' + t('Pick a height, pack and size to get started.') + '</span></div>';
      if (drawerLowstock) drawerLowstock.hidden = true;
      if (reserveTimer) clearInterval(reserveTimer);
      drawerFoot.classList.remove('show');
      if (drawerShip) drawerShip.hidden = true;   // la barra va arriba: con el carrito vacío no se enseña
      var ps = $('drawerProtect'); if (ps) ps.innerHTML = '';
      return;
    }

    var insoleLines = lines.filter(function (p) { return HANDLE_TO_HEIGHT[p.handle]; });
    var cartQty = insoleLines.reduce(function (s, p) { return s + p.quantity; }, 0);
    var lastInsoleKey = insoleLines.length ? insoleLines[insoleLines.length - 1].key : null;
    drawerBody.innerHTML = lines.map(function (p) {
      var h = HANDLE_TO_HEIGHT[p.handle];
      if (!h) {
        if (xsOf(p)) return '';   // vive en "Completa tu set" con el ✓
        return '<div class="cart-item cart-item--addon" data-key="' + esc(p.key) + '">'
          + '<img class="cart-item__img" src="' + esc(p.image || ECM.assets.pack) + '" alt="" loading="lazy" />'
          + '<div class="cart-item__info"><strong>' + esc(p.product_title) + '</strong>'
          + (p.variant_title && p.variant_title !== 'Default Title' ? '<small>' + esc(p.variant_title) + '</small>' : '<small>' + t('Add-on · single unit') + '</small>')
          + '<div class="cart-item__price">' + money(p.final_line_price) + '</div>'
          + '<div class="cart-item__ctrls"><button type="button" data-action="dec" aria-label="' + esc(t('Decrease')) + '">−</button>'
          + '<span class="cart-item__qty">' + p.quantity + '</span>'
          + '<button type="button" data-action="inc" aria-label="' + esc(t('Increase')) + '">+</button></div></div></div>';
      }
      var isBundle = h === 'bundle', q = p.quantity;
      var packLabel = isBundle ? (q === 1 ? t('1 pack') : t('{n} packs', { n: q })) : (q === 1 ? t('1 pair') : t('{n} pairs', { n: q }));
      // número sin "%": la traducción ya lo lleva ("{pct}% dto."); con "15%" salía "15%% dto."
      // 23-oct: el ahorro se enseña sobre el precio tachado (par + recargo del mercado), como en la ficha;
      // sin descuento por pares no se enseña nada (el par suelto no parece rebajado)
      var unit = p.original_price / 100, was = unit + (isBundle ? CUR.bundleSurplus : CUR.surplus);
      var savePct = p.original_line_price > p.final_line_price && was > 0 ? Math.round((was - p.final_price / 100) / was * 100) : 0;
      // empujón según el TOTAL de pares del carrito (el descuento de Shopify cuenta todas las alturas), solo en la última línea
      var nextQ = cartQty === 1 ? 2 : cartQty === 2 ? 3 : cartQty === 4 ? 5 : 0;
      var nextOff = nextQ && p.key === lastInsoleKey && was > 0 ? Math.round((was - packPerPair(unit, nextQ)) / was * 100) + '%' : '';
      return '<div class="cart-item" data-key="' + esc(p.key) + '">'
        + '<img width="400" height="400" class="cart-item__img" src="' + esc(ECM.assets.cartInsole) + '" alt="" loading="lazy" />'
        + '<div class="cart-item__info"><strong>' + esc(heightLabel(h)) + '</strong>'
        // 26-oct (usuario): solo la talla del país ("Talla EU 42–46"), sin la letra ni la otra numeración
        + '<small>' + t('Size {size}', { size: esc(sizeMain(p.variant_title)) }) + '</small>'
        // 26-oct (usuario): "4 pares" y el precio por par en negrita y oscuro; el tachado sigue en gris
        + '<div class="cart-item__meta"><span><b>' + packLabel + '</b> · ' + (savePct ? '<s class="cart-item__was">' + money(Math.round(was * 100)) + '</s> ' : '') + t('{price} each', { price: '<b>' + money(p.final_price) + '</b>' }) + '</span></div>'
        + '<div class="cart-item__ctrls"><button type="button" data-action="dec" aria-label="' + esc(t('Decrease pairs')) + '">−</button>'
        + '<span class="cart-item__qty">' + q + '</span>'
        + '<button type="button" data-action="inc" aria-label="' + esc(t('Increase pairs')) + '">+</button>'
        // 26-oct (mentor): sin tachado ni total en la línea (el total ya está abajo); el % de descuento va junto al − N +
        + (savePct ? '<span class="cart-item__save">' + t('{pct}% off', { pct: savePct }) + '</span>' : '')
        + (nextOff ? '<button type="button" class="cart-item__nudge" data-action="inc">' + (isBundle ? t('+1 pack · save {off}', { off: nextOff }) : t('+1 pair · save {off}', { off: nextOff })) + '</button>' : '')
        + '</div></div></div>';
    }).join('');

    drawerBody.querySelectorAll('.cart-item').forEach(function (node) {
      var key = node.dataset.key, item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      node.querySelectorAll('[data-action="inc"]').forEach(function (b) { b.addEventListener('click', function () { busy(changeBy(item, 1)); }); });
      node.querySelectorAll('[data-action="dec"]').forEach(function (b) { b.addEventListener('click', function () { busy(changeBy(item, -1)); }); });
    });

    renderCrossSell();
    renderTrust();
    renderProtectionAddon();

    // 24-oct (usuario): en vez de "Descuento", lo que se AHORRA respecto al tachado, en verde y destacado
    var saved = 0;
    cart.items.forEach(function (i) {
      var hh = HANDLE_TO_HEIGHT[i.handle], xsI = xsOf(i);
      if (hh && i.original_line_price > i.final_line_price) {
        var wasC = Math.round((i.original_price / 100 + (hh === 'bundle' ? CUR.bundleSurplus : CUR.surplus)) * 100);
        saved += wasC * i.quantity - i.final_line_price;
      } else if (xsI && xsI.was > xsI.price) saved += (xsI.was - xsI.price) * i.quantity;
    });
    if (drawerDisc) {
      drawerDisc.hidden = saved < 1;
      var dl = drawerDisc.querySelector('.drawer__sub-label'); if (dl) dl.textContent = tt('You save ').trim();
      drawerDiscAmt.textContent = money(saved);
    }
    drawerSub.textContent = money(cart.total_price);
    var tl = drawerSub.parentNode && drawerSub.parentNode.querySelector('.drawer__sub-label'); if (tl) tl.textContent = tt('Total');   // 26-oct (mentor): "Total", no "Subtotal"
    renderShipProgress(cart.total_price / 100);
    if (drawerLowstock) { drawerLowstock.hidden = false; startReserveCountdown(); }
    drawerFoot.classList.add('show');
    if (drawerShip) drawerShip.hidden = false;
  }

  // 26-oct-2026: un fallo casi siempre es un carrito desfasado (otra pestaña lo cambió): se recarga en silencio y el
  // aviso solo sale si ni eso funciona. Antes salía el aviso de error y la línea se quedaba con la cantidad vieja.
  function busy(p) {
    drawer.classList.add('is-busy');
    return p.catch(function (e) { console.error(e); return Cart.refresh().catch(function () { alert(t('There was an issue with your cart. Please refresh and try again.')); }); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  // lee el carrito real antes de tocarlo (la copia de esta página puede estar vieja si hay otra pestaña abierta)
  function fresh(fn) { return Cart.refresh().catch(function () {}).then(fn); }
  function changeBy(item, delta) {
    return fresh(function () {
      var items = (cart && cart.items) || [];
      var cur = items.filter(function (i) { return i.key === item.key; })[0] || items.filter(function (i) { return i.variant_id === item.variant_id; })[0];
      if (!cur) return delta > 0 ? Cart.add([{ id: item.variant_id, quantity: delta }]) : cart;
      return Cart.change(cur.key, Math.max(0, cur.quantity + delta));
    });
  }

  /* Cross-sell "Completa tu set": los añadidos se quedan en ✓ y otro toque los quita */
  function renderCrossSell() {
    if (!XS.length) return;
    var block = document.createElement('div');
    block.className = 'cart-xs';
    block.innerHTML = '<div class="cart-xs__title">' + t('Complete your set') + '</div><div class="cart-xs__list">'
      + XS.map(function (xs) {
        var inCart = cart.items.some(function (i) { return i.variant_id === xs.id; });
        var off = xs.was && xs.was > xs.price ? ' <s>' + money(xs.was) + '</s> <span class="cart-xs__off">-' + Math.round((1 - xs.price / xs.was) * 100) + '%</span>' : '';
        // 24-oct (usuario): tarjeta pequeña (foto al lado del nombre, sin reseñas) para que se vea sin hacer scroll
        return '<div class="cart-xs__card' + (inCart ? ' is-added' : '') + '" data-xs-id="' + xs.id + '">'
          + '<img class="cart-xs__img" src="' + esc(ECM.assets[xs.img] || xs.image) + '" alt="' + t(xs.name) + '" loading="lazy" />'
          + '<div class="cart-xs__info"><div class="cart-xs__name">' + t(xs.name) + '</div>'
          + '<div class="cart-xs__price"><strong>' + money(xs.price) + '</strong>' + off + '</div></div>'
          + '<button type="button" class="cart-xs__add' + (inCart ? ' is-added' : '') + '" aria-label="' + esc(t('Add {name}', { name: t(xs.name) })) + '">' + (inCart ? t('✓ Added') : t('Add')) + '</button></div>';
      }).join('') + '</div>';
    drawerBody.appendChild(block);
    block.querySelectorAll('.cart-xs__card').forEach(function (card) {
      var id = Number(card.dataset.xsId);
      card.querySelector('.cart-xs__add').addEventListener('click', function (ev) {
        var b = ev.currentTarget, wantOn = !b.classList.contains('is-added');   // lo que el cliente ve y quiere, no la copia vieja del carrito
        var xsi = XS.filter(function (x) { return x.id === id; })[0] || {};
        stat('cross_sell_toggle', wantOn ? { product: xsi.handle || String(id), on: true, price: +((xsi.price || 0) / 100).toFixed(2) } : { product: xsi.handle || String(id), on: false });
        if (wantOn) { b.disabled = true; b.classList.add('is-added'); b.textContent = tt('✓ Added'); card.classList.add('is-added'); }
        busy(fresh(function () {
          var line = cart.items.filter(function (i) { return i.variant_id === id; })[0];
          if (wantOn) return line ? cart : Cart.add([{ id: id, quantity: 1 }]);
          return line ? Cart.change(line.key, 0) : cart;
        }));
      });
    });
  }

  // 24-oct (usuario): fila de confianza en el carrito, como las grandes tiendas
  function renderTrust() {
    var ic = {
      heart: '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/>',
      truck: '<rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>',
      shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>'
    };
    var items = [['heart', t('115,000+ happy customers')], ['truck', t('Tracked & shipped fast')], ['shield', t('90-day money-back guarantee')]];
    var row = document.createElement('div');
    row.className = 'cart-trust';
    row.innerHTML = items.map(function (it) {
      return '<div class="cart-trust__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ic[it[0]] + '</svg><span>' + it[1] + '</span></div>';   // t() ya escapa: con esc() salía "Tracked &amp;amp; shipped"
    }).join('');
    drawerBody.appendChild(row);
  }

  function renderProtectionAddon() {
    if (!ECM.protection) return;
    var on = hasProtection();
    var wrap = document.createElement('label');
    wrap.className = 'drawer__addon drawer__addon--protect' + (on ? ' active' : '');
    wrap.innerHTML = '<span class="drawer__addon-shield" aria-hidden="true">🛡️</span>'
      + '<span class="drawer__addon-info">' + t('<strong>Package Protection</strong> <em>Recommended</em>') + ' '
      + t('<small>Free replacement if your package is lost, stolen or damaged in transit.</small>') + '</span>'
      + '<span class="drawer__addon-right"><span class="drawer__addon-price">' + money(ECM.protection.price) + '</span><span class="drawer__addon-switch"></span></span>';
    var slot = $('drawerProtect') || drawerBody;
    slot.innerHTML = ''; slot.appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      var wantOn = !wrap.classList.contains('active');   // lo que el cliente ve, no la copia vieja del carrito
      try { localStorage.setItem('ecm_protect_off', wantOn ? '0' : '1'); } catch (err) {}
      stat('protection_toggle', { on: wantOn, price: +(ECM.protection.price / 100).toFixed(2) });
      busy(fresh(function () {
        var line = cart.items.filter(isProtection)[0];
        if (wantOn) return line ? cart : Cart.add([{ id: ECM.protection.id, quantity: 1 }]);
        return line ? Cart.change(line.key, 0) : cart;
      }));
    });
  }

  // packs del mentor (23-oct-2026): los mismos porcentajes que la ficha y los descuentos automáticos de Shopify
  var PACK_OFF = { 1: 0, 2: 0.1220, 3: 0.1952, 4: 0.1952, 5: 0.2684 };
  function packPerPair(unit, q) { var o = PACK_OFF[Math.min(Math.max(q, 1), 5)], d = FMT.decimals === 0 ? 1 : 100; return unit - Math.floor(unit * o * d + 1e-9) / d; }   // CLP/COP/JPY: a la unidad, como Shopify

  /* Barra del carrito (23-oct-2026): regalos según los pares, como en la ficha
     (2 → AuraPod S · 3 → + Travel Pack · 5 → el pack completo; el pack de 3 alturas cuenta 3),
     y debajo lo que falta para el envío gratis (umbral del mercado). */
  var shipUnlocked = false;
  function renderShipProgress(subtotal) {
    if (!drawerShip) return;
    var min = CUR.freeShip || 40, remaining = Math.max(0, min - subtotal);
    // Test 4 (26-oct, mentor; ajuste cart_test_on): la B no lleva la caja verde de regalos, solo la línea del envío gratis y su barra
    var hc = document.documentElement.classList;
    if (window.ECM_AB === 'B' && hc.contains('ecm-test-cart')) {
      drawerShip.classList.add('drawer__ship--simple');
      drawerShipFill.style.width = Math.min(100, Math.round(subtotal / min * 100)) + '%';
      drawerShipMsg.innerHTML = remaining <= 0 ? t('🎉 <strong>Free shipping unlocked!</strong>')
        : t("You're <strong>{amount}</strong> away from <strong>FREE shipping</strong>", { amount: moneyMajor(remaining) });
      return;
    }
    var pairs = cart.items.reduce(function (s, p) { var h = HANDLE_TO_HEIGHT[p.handle]; return h ? s + p.quantity * (h === 'bundle' ? 3 : 1) : s; }, 0);
    var steps = [{ n: 2, label: tt('Perfume + e-book') }, { n: 3, label: tt('Travel bag') }, { n: 5, label: tt('Full pack') }];   // 24-oct: 2 pares = 2 regalos
    var POS = [0, 14, 30, 62, 81, 100];   // % de la barra por número de pares (2 y 3 separados para que quepan los nombres)
    var els = drawerShip.querySelectorAll('.drawer__ship-node');
    steps.forEach(function (st, i) {
      var el = els[i]; if (!el) return;
      var b = el.querySelector('b'), lab = el.querySelector('i');
      if (b) b.textContent = st.n; if (lab) lab.textContent = st.label;
      el.style.left = POS[st.n] + '%';
      el.classList.toggle('is-done', pairs >= st.n);
    });
    drawerShipFill.style.width = POS[Math.min(pairs, 5)] + '%';
    var got = pairs >= 5 ? 4 : pairs >= 3 ? 3 : pairs >= 2 ? 2 : 0;
    // ARRIBA lo que falta para el siguiente regalo; ABAJO lo que ya lleva: envío + regalos (usuario, 24-oct)
    drawerShipMsg.innerHTML = (pairs < 2 ? t('🎁 Add a 2nd pair and get 2 FREE bonuses') : pairs === 2 ? t('🎁 Add a 3rd pair and get a FREE travel bag')
      : pairs === 3 ? t('🎁 Add 2 more pairs and get the full bonus pack') : pairs === 4 ? t('🎁 Add 1 more pair and get the full bonus pack') : t('🎉 Full bonus pack unlocked!'));
    drawerShip.classList.toggle('is-unlocked', got === 4);
    if (got === 4 && !shipUnlocked) fireConfetti();
    shipUnlocked = got === 4;
    var giftTxt = got === 2 ? t('2 FREE bonuses included') : got === 3 ? t('3 FREE bonuses included') : got === 4 ? t('all 4 FREE bonuses included') : '';
    if (drawerShipSub) drawerShipSub.innerHTML = (remaining <= 0 ? t('🎉 <strong>Free shipping unlocked!</strong>')
      : t("You're <strong>{amount}</strong> away from <strong>FREE shipping</strong>", { amount: moneyMajor(remaining) }))
      + (giftTxt ? (remaining <= 0 ? ' + ' : ' · ') + '<strong>' + giftTxt + '</strong>' : '');
  }
  function fireConfetti() {
    var colors = ['#15A65A', '#3EE49C', '#00C8F0', '#FFD166', '#EF476F', '#C9A96E', '#ffffff'];
    var wrap = document.createElement('div'); wrap.className = 'confetti';
    for (var i = 0; i < 70; i++) {
      var p = document.createElement('i');
      p.style.left = (Math.random() * 100) + '%'; p.style.background = colors[i % colors.length];
      p.style.animationDelay = (Math.random() * 0.25) + 's'; p.style.animationDuration = (0.9 + Math.random() * 0.7) + 's';
      p.style.height = (8 + Math.random() * 10) + 'px'; wrap.appendChild(p);
    }
    document.body.appendChild(wrap); setTimeout(function () { wrap.remove(); }, 1900);
  }

  /* Cuenta atrás de reserva (10 min, persistente en la sesión) */
  var reserveTimer = null, reserveDeadline = 0;
  function startReserveCountdown() {
    if (!drawerReserve) return;
    try { reserveDeadline = +sessionStorage.getItem('xcm_reserve') || 0; } catch (e) { reserveDeadline = 0; }
    if (!reserveDeadline || reserveDeadline <= Date.now()) {
      reserveDeadline = Date.now() + 10 * 60 * 1000;
      try { sessionStorage.setItem('xcm_reserve', reserveDeadline); } catch (e) {}
    }
    runReserveTick();
  }
  function runReserveTick() {
    if (reserveTimer) clearInterval(reserveTimer);
    function tick() {
      var ms = reserveDeadline - Date.now();
      if (ms <= 0) { clearInterval(reserveTimer); drawerReserve.textContent = '0:00'; showReserveExpired(); return; }
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      drawerReserve.textContent = m + ':' + String(s).padStart(2, '0');
    }
    tick(); reserveTimer = setInterval(tick, 1000);
  }
  function showReserveExpired() {
    if (!reserveModal || !reserveModalBody) return;
    reserveModal.classList.add('show');
    reserveModalBody.innerHTML = '<div class="reserve-modal__spin"></div><p>' + t('Re-checking availability…') + '</p>';
    setTimeout(function () {
      reserveModalBody.innerHTML = '<p class="reserve-modal__ok">' + t('✓ Still in stock!') + '</p><p>' + t("Good news — your items are still available. We've held them for another 10 minutes.") + '</p><button type="button" class="reserve-modal__btn" id="reserveKeep">' + t('Keep my items') + '</button>';
      var btn = $('reserveKeep'); if (btn) btn.addEventListener('click', restartReserve);
    }, 1600);
  }
  function restartReserve() {
    if (reserveModal) reserveModal.classList.remove('show');
    reserveDeadline = Date.now() + 10 * 60 * 1000;
    try { sessionStorage.setItem('xcm_reserve', reserveDeadline); } catch (e) {}
    runReserveTick();
  }

  // eventos del panel /stats (mismos nombres y datos que la web)
  function stat(n, props) { try { (window.ecmq = window.ecmq || []).push([n, props]); } catch (e) {} }

  function openDrawer() {
    if (!drawer) return;
    var lines = cart ? cart.items.filter(function (i) { return !isProtection(i); }) : [];
    stat('cart_open', { value: +(lines.reduce(function (s, i) { return s + i.final_line_price; }, 0) / 100).toFixed(2), currency: (cart && cart.currency) || CUR.cur, lines: lines.length });
    drawer.classList.add('open'); overlay.classList.add('show');
    drawer.setAttribute('aria-hidden', 'false'); drawer.inert = false;
    document.body.style.overflow = 'hidden'; document.body.classList.add('modal-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open'); overlay.classList.remove('show');
    drawer.setAttribute('aria-hidden', 'true'); drawer.inert = true;
    document.body.style.overflow = ''; document.body.classList.remove('modal-open');
  }
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', function () { closeDrawer(); document.dispatchEvent(new CustomEvent('ecm:overlay')); });
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer(); });

  /* ---------------- seguimiento (mismo formato que la web) ----------------
     Meta y TikTok reciben el mismo id de la web ("h5-sL" = 5 cm, talla L), no el
     de Shopify, para que el cambio de web no les cambie los datos. InitiateCheckout
     NO va a Meta desde aquí: lo manda Sonar (Triple Whale) por servidor. */
  var TW_PRODUCT = {};
  Object.keys(ECM.products || {}).forEach(function (h) { if (ECM.products[h]) TW_PRODUCT[h] = String(ECM.products[h].id); });
  var HANDLE_H = {};
  Object.keys(ECM.products || {}).forEach(function (h) { if (ECM.products[h]) HANDLE_H[ECM.products[h].handle] = h; });
  function abPdp() { return window.ECM_AB || (document.cookie.match(/(?:^|;\s*)extracm_ab=([AB])/) || [])[1] || 'A'; }
  function webId(h, size) { return 'h' + h + '-s' + size; }
  function itemWebId(i) { var h = HANDLE_H[i.handle]; return h ? webId(h, i.variant_options && i.variant_options[0] || i.variant_title) : String(i.variant_id); }
  function trackAddToCart(o) {   // { h, size, qty, perPair, variantId, source }
    var id = webId(o.h, o.size), value = +(o.perPair * o.qty).toFixed(2), cur = ECM.currency;
    try { (window.ecmq = window.ecmq || []).push(['add_to_cart', { source: o.source || 'main', pack: o.h === 'bundle' ? 'bundle' : String(o.qty), height: String(o.h), size: String(o.size), value: value, currency: cur }]); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', 'add_to_cart', { ab_pdp: abPdp(), currency: cur, value: value, items: [{ item_id: id, item_name: 'ExtraCM Soft Pro', item_variant: heightLabel(o.h) + ' / ' + o.size, price: o.perPair, quantity: o.qty }] }); } catch (e) {}
    try { if (typeof fbq === 'function') fbq('track', 'AddToCart', { content_name: 'ExtraCM Soft Pro', content_type: 'product', contents: [{ id: id, quantity: o.qty }], value: value, currency: cur }); } catch (e) {}
    try { if (typeof ttq !== 'undefined') ttq.track('AddToCart', { contents: [{ content_id: id, content_type: 'product', content_name: 'ExtraCM Soft Pro', quantity: o.qty, price: +o.perPair.toFixed(2) }], value: value, currency: cur }); } catch (e) {}
    try { if (window.ExtraCMConsent && ExtraCMConsent.tw && o.variantId && TW_PRODUCT[String(o.h)]) ExtraCMConsent.tw('AddToCart', { item: TW_PRODUCT[String(o.h)], q: o.qty, v: String(o.variantId) }); } catch (e) {}
  }
  function trackBeginCheckout() {
    if (!cart || !cart.items.length) return;
    var cur = ECM.currency, value = +(cart.total_price / 100).toFixed(2);
    var items = cart.items.map(function (i) {
      var ins = !!HANDLE_H[i.handle];
      return { item_id: itemWebId(i), item_name: ins ? 'ExtraCM Soft Pro' : i.product_title, item_variant: ins ? heightLabel(HANDLE_H[i.handle]) + ' / ' + (i.variant_options && i.variant_options[0]) : 'Add-on', price: +(i.final_price / 100).toFixed(2), quantity: i.quantity };
    });
    try { if (typeof gtag === 'function') gtag('event', 'begin_checkout', { ab_pdp: abPdp(), currency: cur, value: value, items: items }); } catch (e) {}
    try { if (typeof ttq !== 'undefined') ttq.track('InitiateCheckout', { contents: items.map(function (it) { return { content_id: it.item_id || 'extracm-soft-pro', content_type: 'product', quantity: it.quantity, price: it.price }; }), value: value, currency: cur }); } catch (e) {}
    try { (window.ecmq = window.ecmq || []).push(['begin_checkout', { value: value, currency: cur, lines: items.map(function (it) { return it.item_id; }).join(',') }]); } catch (e) {}
  }

  /* Pagar: atributos del pedido (página y mercado) y, si el pop-up dejó un
     código, se aplica por la URL /discount antes de entrar en el checkout. */
  if (checkoutBtn) checkoutBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (!cart || !cart.items.length) return;
    var original = checkoutBtn.textContent;
    checkoutBtn.textContent = tt('→ Redirecting…'); checkoutBtn.disabled = true;
    var dc = ''; try { dc = localStorage.getItem('extracm_discount') || ''; } catch (err) {}
    var attrs = { pg: document.body.dataset.page || '', mkt: String(ECM.country || '').toLowerCase(), src: 'shopify-theme' };
    if (window.ECM_AB) attrs.ab = window.ECM_AB;   // versión del test A/B (misma clave que en la web)
    try { if (window.ecmStats) attrs.sid = window.ecmStats.sid(); } catch (err) {}   // une el pedido con su visita en el panel /stats
    trackBeginCheckout();
    Cart.update({ attributes: attrs }).catch(function () {}).then(function () {
      window.location.href = dc ? ROOT + 'discount/' + encodeURIComponent(dc) + '?redirect=/checkout' : '/checkout';
    });
    setTimeout(function () { checkoutBtn.textContent = original; checkoutBtn.disabled = false; }, 15000);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && checkoutBtn) { checkoutBtn.textContent = tt('Checkout →'); checkoutBtn.disabled = false; } });

  /* Test A/B: a los visitantes B, los enlaces a las plantillas llevan ?view=b
     para no pasar por la A y que el <head> tenga que redirigir. */
  if (window.ECM_AB === 'B') {
    var insolePaths = Object.keys(ECM.products || {}).map(function (k) { return (ECM.products[k] || {}).url; }).filter(Boolean);
    document.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (u.origin !== location.origin || insolePaths.indexOf(u.pathname) === -1 || u.searchParams.has('view')) return;
        u.searchParams.set('view', 'b'); a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  /* Menú lateral (hamburguesa de la barra de la portada y de la cabecera de
     la página de venta; antes vivía en home.js y la PDP no lo cargaba) */
  (function () {
    var burger = $('burger'), nd = $('navdrawer');
    if (!burger || !nd) return;
    var toggle = function (force) {
      var open = force !== undefined ? force : !nd.classList.contains('open');
      nd.classList.toggle('open', open); burger.classList.toggle('active', open);
      nd.setAttribute('aria-hidden', String(!open)); burger.setAttribute('aria-expanded', String(open));
    };
    burger.addEventListener('click', function () { toggle(); });
    nd.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', function () { toggle(false); }); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nd.classList.contains('open')) toggle(false); });
  })();

  /* Mercado por IP. Shopify no cambia de país solo: todo el mundo cae en el
     mercado principal (GB, libras). Se le pide su sugerencia por IP una vez
     por visitante y, si el país sugerido es un mercado distinto del actual, se
     cambia con el formulario de localización (una recarga). Los rastreadores
     y los navegadores headless no entran. */
  /* País de la IP → idioma de Shopify. Es el GEO_MAP de scripts/i18n/geo.js (la web manda
     a un japonés a /ja, a un mexicano a /mx, a un belga a /fr…). Los países en inglés
     (GB, US, CA, IE, AU, NZ) no están: se quedan en el idioma por defecto. */
  var COUNTRY_LANG = { ES: 'es', MX: 'es', CL: 'es', CO: 'es', PE: 'es', PA: 'es', UY: 'es', FR: 'fr', BE: 'fr', LU: 'fr',
    IT: 'it', DE: 'de', AT: 'de', PT: 'pt-PT', NL: 'nl', PL: 'pl', CZ: 'cs', GR: 'el', JP: 'ja' };
  (function geoMarket() {
    if (/bot|crawl|spider|slurp|facebookexternalhit|preview|lighthouse|headless/i.test(navigator.userAgent)) return;
    var KEY = 'extracm_geo_done', form = document.getElementById('ecmLocalization');
    // Si llega desde extracm.com, la redirección ya trae el país (?country=): manda
    // la ruta de la web, como hoy (un español en /mx ve pesos). No se toca.
    try { if (new URLSearchParams(location.search).get('country')) { localStorage.setItem(KEY, '1'); return; } } catch (e) {}
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
    if (!form || !ECM.country) return;
    // Igual que el geo de la web: solo las rutas SIN idioma (la raíz inglesa) se
    // adaptan por IP. Si la URL ya lleva idioma (/es/…, /ja/…) manda la ruta.
    if (String(ECM.root || '/').replace(/\/$/, '') !== '') { try { localStorage.setItem(KEY, '1'); } catch (e) {} return; }
    fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        var s = d && d.suggestions && d.suggestions[0], cc = s && s.country && s.country.handle;
        if (!cc) return;
        var lang = COUNTRY_LANG[cc] || '';
        // Puerto Rico es el país US para Shopify: un hispanohablante de US ve la tienda en español (textos de PR)
        if (cc === 'US' && /^es\b/i.test(navigator.language || '')) lang = 'es';
        var cur = String(ECM.locale || 'en').toLowerCase();
        if (cc === ECM.country && (!lang || lang.toLowerCase() === cur)) return;
        var rt = form.querySelector('[name=return_to]');
        if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
        rt.value = location.pathname + location.search + location.hash;
        form.querySelector('[name=country_code]').value = cc;
        if (lang) form.querySelector('[name=language_code]').value = lang;
        form.submit();
      }).catch(function () {});
  })();

  /* La redirección desde extracm.com llega con ?country=, ?abv= y ?view=b. Una vez
     cargada la página ya han hecho su trabajo (Shopify guardó el mercado en su cookie,
     la versión A/B está decidida en el <head> y los scripts diferidos ya los leyeron),
     así que se quitan de la barra de direcciones. fbclid y utm se quedan. */
  window.addEventListener('load', function () {
    try {
      var q = new URLSearchParams(location.search), had = false;
      ['country', 'abv', 'view'].forEach(function (k) { if (q.has(k)) { q.delete(k); had = true; } });
      if (had) history.replaceState(history.state, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash);
    } catch (e) {}
  });

  /* Altura real del viewport en iOS (la barra de Safari) */
  function setAppHeight() {
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    document.documentElement.style.setProperty('--app-h', h + 'px');
  }
  setAppHeight();
  window.addEventListener('resize', setAppHeight);
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', setAppHeight); window.visualViewport.addEventListener('scroll', setAppHeight); }

  /* Ficha sencilla de los extras */
  document.querySelectorAll('[data-simple-add]').forEach(function (btn) {
    var sel = document.querySelector('[data-simple-variant]');
    if (sel) sel.addEventListener('change', function () {
      btn.dataset.simpleAdd = sel.value;
      var o = sel.options[sel.selectedIndex], now = document.querySelector('.simple-product__now');
      if (o && now && o.dataset.price) now.textContent = money(o.dataset.price);
    });
    btn.addEventListener('click', function () {
      btn.disabled = true;
      Cart.add([{ id: Number(btn.dataset.simpleAdd), quantity: 1 }]).then(function () { renderCart(); openDrawer(); }).catch(function () { alert(t('There was an issue with your cart. Please refresh and try again.')); }).then(function () { btn.disabled = false; });
    });
  });

  Cart.onChange(renderCart);
  Cart.onChange(fixProtectionQty);
  // al volver a esta pestaña, el carrito puede haber cambiado en otra: se vuelve a leer
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') Cart.refresh().catch(function () {}); });
  Cart.refresh().catch(function (e) { console.warn('cart', e); });
  localizeStatic(document);
  convertGbpLeft(document);

  window.ECMTheme = {
    t: t, tt: tt, money: money, moneyMajor: moneyMajor, CUR: CUR, FMT: FMT, Cart: Cart,
    addWithProtection: addWithProtection, openDrawer: openDrawer, closeDrawer: closeDrawer,
    renderCart: renderCart, heightLabel: heightLabel, sizeRange: sizeRange, sizeSystem: sizeSystem,
    trackAddToCart: trackAddToCart, relabelSizes: relabelSizes,
    convertDecorative: convertDecorative, localizeStatic: localizeStatic, needsConversion: needsConversion
  };
})();
